import type { FC } from "react";
import React from "react";

import type { ShowProps } from "./types";

const Show: FC<ShowProps> = ({ when, children }) => {
  if (!when) return null;
  return <>{children}</>;
};

export default Show;
